/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./NavigatorDialog',
	'react',
	'react-dom'
], function (NavigatorDialog, React, ReactDOM) {

	class SaveAsDialog extends NavigatorDialog {

		constructor(options) {
			super(options);
			this.defaultFileName = options.defaultFileName;
			this.service = options.service;
			this.onHide = options.onHide;
		}

		open() {
			this.isOpen = true;
			return this.render();
		}

		hide() {
			this.isOpen = false;
			if (this.onHide) {
				this.onHide();
			}
		}

		closeDialog() {
			this.isOpen = false;
			const mountPoint = document.getElementById('saveAsDialog');
			ReactDOM.unmountComponentAtNode(mountPoint);
			mountPoint.parentNode.removeChild(mountPoint);
		}

		render() {
			return this._getFolderData().then((folderInfo) => {
				const options = {
					glassContext: this.glassContext,
					isOpen: this.isOpen,
					defaultFileName: this.defaultFileName,
					service: this.service,
					onClose: this.hide.bind(this),
					closeDialog: this.closeDialog.bind(this),
					selectedTabId: folderInfo.tab,
					pathRef: folderInfo.folder
				};
	
				let mountPoint = document.createElement('div');
				mountPoint.setAttribute('id', 'saveAsDialog');
				document.body.appendChild(mountPoint);
	
				return new Promise((resolve, reject) => {
					require(['ca-content/home/caHome'], (caHome) => {
						ReactDOM.render(React.createElement(caHome.SaveAsDialog, options), mountPoint);
						resolve();
					}, reject);
				});
			});
		}
	}
	return SaveAsDialog;
});
